<template>
  <div>
    <div class="editor" ref="editor" contenteditable="true" @input="input" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    editor() {
      return this.$refs.editor || {};
    },
  },
  methods: {
    input(e) {
      this.$emit("inputDetail", this.getEditorHtml());
    },

    clearInput() {
      this.editor.innerHTML = "";
    },
    
    getEditorHtml() {
      return this.editor.innerHTML || "";
    },
  },
};
</script>

<style scoped>
.editor {
  overflow-y: auto;
  background: #fff;
  border-radius: 4px;
  border: 1px solid transparent;
  min-height: 40px;
  max-height: 600px;
  padding: 10px 9px;
  line-height: 20px;
  height: 180px;
  margin: 10px 10px;
}
:empty::before {
  content: "您遇到过哪些养老问题？体会过哪些养老痛点？";
  color: #999;
}
:focus {
  outline: none;
  border-color: #d8d8d8;
  border-radius: 4px;
}
</style>
